/**************************************************
 * Nombre:       Tarjeta_Mesa_Vista_Rerserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {TableRestaurant} from '@mui/icons-material'
import {theme} from "../../Tema";

const Tarjeta_Mesa_Vista_Rerserva = ({item, escogida, cambia}) => {

    return (
        <Grid
            onClick={() => cambia(item)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: item.id === escogida.id ? theme.palette.primary.main : '#fff',
                borderRadius: 1,
                boxShadow: 4,
                p: 1,
                cursor: 'pointer',
                color:  item.id === escogida.id ? '#fff' : '#000',
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <TableRestaurant
                    sx={{width: 80, height: 80, fill: item.id !== escogida.id ? theme.palette.primary.main : '#fff',}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 300, fontSize: 12}}>{`Max Per: ${item.numPersonas}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 300, fontSize: 12}}>{`Tipo: ${item.tipo}`}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Mesa_Vista_Rerserva